module.exports = __webpack_public_path__ + "img/logo-sd-us.4535928f.png";